import { render, staticRenderFns } from "./movePart.vue?vue&type=template&id=c3d23ad6&scoped=true&"
import script from "./movePart.vue?vue&type=script&lang=js&"
export * from "./movePart.vue?vue&type=script&lang=js&"
import style0 from "./movePart.vue?vue&type=style&index=0&id=c3d23ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d23ad6",
  null
  
)

export default component.exports